import classNames from "classnames";

import "../../styles/resources.css";
import { BmsHeader } from "../../components/main-components/app.header";
import { AppFooter } from "../../components/main-components/footer";
import { buttonsData } from "../../helpers/mock-data";
import { SkewBox } from "../../components/page/skew";





export const TutorialsPage = () => {

    

    return (
        <div className='page-body'>
            <BmsHeader />
            <SkewBox
                title={"Tutorial Quizes"}
                background={"/media/resources.jpg"}
            />
            <div className="field-caption">
                Choose field of study
            </div>
            <div className="res-buttons">
                {buttonsData.map((data, k) => (
                    <div
                        className='res-unit'
                        style={{ backgroundImage: `url(${data.background})` }}
                        key={k}
                    >
                        <button
                            className={classNames("res-button")}
                            onClick={() => {
                               window.location.href= `/tutorialpage?field=${data.caption}`
                            }}
                            key={k}
                        >
                            <span className="res-button-cap">{data.caption}</span>
                        </button>

                    </div>
                ))}
            </div>
            <AppFooter />
        </div>
    )
}